import { render, staticRenderFns } from "./ErrorBudget.vue?vue&type=template&id=e5d35e2c&"
import script from "./ErrorBudget.vue?vue&type=script&lang=js&"
export * from "./ErrorBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports